import { IconSparkles } from '@tabler/icons-solidjs'
import { splitProps } from 'solid-js'
import { cn } from '../lib/cn.ts'

interface SparkIconProps {
  class?: string
}

export const SparkIcon = (props: SparkIconProps) => {
  const [local] = splitProps(props, ['class'])

  return (
    <IconSparkles
      size={16}
      strokeWidth={1.5}
      class={cn('size-4 shrink-0', local.class)}
      aria-hidden="true"
    />
  )
}
